import { ComponentKey } from '@canvas-logic/clp-domain';
import { ComponentProductDataLookup, IComponentProductDataLookup } from '@/ui-kit/domain/ComponentProductDataLookup';
import { ICompositeProductApi } from '@canvas-logic/clp-sdk';

export class LookupStorage {
  productDataLookups = new Map<ComponentKey, IComponentProductDataLookup>();
  constructor(private api: ICompositeProductApi) {}

  update() {
    this.productDataLookups.forEach((lookup) => lookup.updateValues());
  }
  getDataLookup(componentKey: ComponentKey): IComponentProductDataLookup {
    if (!this.productDataLookups.has(componentKey)) {
      this.productDataLookups.set(componentKey, new ComponentProductDataLookup(this.api, componentKey));
    }
    return this.productDataLookups.get(componentKey)!;
  }
}
